class Toolbarmobile extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = null;
    if (theme.config.mqlSmall || theme.config.isTouch) this.init();
  }

  init() {
    this.activate();

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;

        const borderBox = entry.borderBoxSize;
        const height = borderBox && borderBox.length
          ? borderBox[0].blockSize
          : entry.contentRect.height;

        document.body.style.setProperty('--toolbar-mobile-height', `${Math.round(height)}px`);
      });
      this.resizeObserver.observe(this);
    } else {
      this.setHeight();
      this._boundResize = theme.utils.rafThrottle(this.setHeight.bind(this));
      window.addEventListener('resize', this._boundResize, { passive: true });
    }
  }

  activate() {
    const header = document.querySelector(".header[data-sticky-state='inactive']");
    header === null
      ? this.classList.add('active')
      : this.classList.remove('active');
  }

  setHeight() {
    document.body.style.setProperty('--toolbar-mobile-height', `${this.clientHeight}px`);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this._boundResize) {
      window.removeEventListener('resize', this._boundResize);
      this._boundResize.cancel?.();
    }
  }
}

if (!customElements.get('toolbar-mobile')) {
  customElements.define('toolbar-mobile', Toolbarmobile);
}
